import { OnDeckExtraDataForm } from "@/components/applications/upload-documents/OnDeckExtraDataForm"
import { isOnDeckExtraDataValid } from "@/lib/integrations/ondeck"

import type { LenderProfileReferralIntegration } from "@boundless/bl-api-client/customer/models"

type ReferralIntegration =
  (typeof LenderProfileReferralIntegration)[keyof typeof LenderProfileReferralIntegration]

/**
 * @summary Get the Extra Data Form component
 */
export function getExtraDataFormComponent(
  integration: ReferralIntegration | undefined,
) {
  return integration === "ondeck" ? OnDeckExtraDataForm : null
}

const alwaysTrue = () => true

export function getExtraDataValidationFn(
  integration: ReferralIntegration | undefined,
): (data: unknown) => boolean {
  if (!integration) {
    return alwaysTrue
  }
  return integration === "ondeck" ? isOnDeckExtraDataValid : alwaysTrue
}
